export default __webpack_public_path__ + "static/earthquake-damage-9a9a2d3f46853896f5fa3f31e02e6036.jpeg";